import React, { PureComponent } from 'react';
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import getGraphqlURI from 'utils/getGraphqlURI'
import RefetchOnLocaleChange from 'utils/RefetchOnLocaleChange'
//This component is for language unique search functionality on the website. Search is unique for each language page
export default (getSearch, key = 'searchResults', getLocale = props => props.language.params.language) => WrappedComponent => class WithLangSearch extends PureComponent {
    render() {
        const search = getSearch(this.props)
        const locale = getLocale(this.props)
        return (
            <Query
                variables={search}
                context={{
                    uri: getGraphqlURI(locale)
                }}
                query={gql`
          query Documents($search: String) {
           
            
            pages: pages(
              first: 100
              where: {
                search: $search
              }
              ) {
              nodes {
                id
                title
                link
                date
                status
                modules {
                  ...on Modules__bodyText {
                    body
                  }
                  ...on Modules__imageAndText {
                    body
                  }
                }
              }
            }
            
            products: products(
              first: 100
              where: {
                search: $search}
                ) {
              nodes {
                id
                title
                link
                date
                status
                key
                image {
                  sourceUrl
                }
              }
            }
            pagesTags: pages(
              first: 100
              where: {
                tagSlugIn: [$search]
              }
              ) {
              nodes {
                id
                title
                link
                date
                status
                modules {
                  ...on Modules__bodyText {
                    body
                  }
                  ...on Modules__imageAndText {
                    body
                  }
                }
              }
            }
            productsTags: products(
              first: 100
              where: {
                tagSlugIn: [$search]}
                ) {
              nodes {
                id
                title
                link
                date
                status
                key
                image {
                  sourceUrl
                }
              }
            }

          }
        `}
            >
                {({ loading, error, data, refetch }) => (
                    <div>
                        {!error &&
                            <RefetchOnLocaleChange locale={locale} refetch={refetch}>
                                <WrappedComponent
                                    {...this.props}
                                    {...{
                                        [`${key}Loading`]: loading,
                                        [key]: !loading ? data : undefined
                                    }}
                                />
                            </RefetchOnLocaleChange>
                        }
                        {error && <h1>Error: {error.message}</h1>}
                    </div>
                )}
            </Query>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/withLangSearch.js